<!-- =========================================================================================
  File Name: addSidebarView.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "EDIT" }} LOCATION</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6 pb-0">

        <!-- NAME -->
        <vs-input label="Name *" v-model="dataName" @input="checkName" class="mt-5 w-full" name="name" v-validate="'required'" maxlength="50"/>
        <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
        <span class="text-danger text-sm" v-if="LocationDuplicate>0">Name already has been taken!</span>
                 <!-- Address -->
        <vs-input label="Address *" v-model="dataAddress" class="mt-5 w-full" name="address" v-validate="'required'" maxlength="100" />
        <span class="text-danger text-sm" v-show="errors.has('address')">{{ errors.first('address') }}</span>

                <!-- EMAIL -->
        <vs-input label="Email" v-model="dataEmail" class="mt-5 w-full" name="email" v-validate="'email'" />
        <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
        <!-- PHONE -->
        <vs-input :label="$t('user.add.phone_no') +'*'" v-model="dataPhone"  @input="acceptNumber" class="mt-5 w-full" :name="$t('user.add.phone_no')"/>
        <span class="text-danger text-sm" v-show="errors.has($t('user.add.phone_no'))">{{ errors.first($t('user.add.phone_no')) }}</span>
     <!-- Latitude -->
        <vs-input label="Latitude" name="latitude" v-model="dataLatitude" class="mt-5 w-full" maxlength="50" />
        <span class="text-danger text-sm" v-show="errors.has('latitude')">{{ errors.first('latitude') }}</span>
             <!-- Longitude -->
        <vs-input label="Longitude" name="longitude" v-model="dataLongitude" class="mt-5 w-full" maxlength="50"  />
        <span class="text-danger text-sm" v-show="errors.has('longitude')">{{ errors.first('longitude') }}</span>
        <br>
              <!-- Pin Url -->
        <!-- <vs-input label="Pin Url " v-model="dataPin" class="mt-5 w-full"  /> -->

         <label class="vs-select--label w-full">Select Timezone *</label>
        <v-select  label="name"   :closeOnSelect="true" v-model="dataTimezone"  :options="timezones"  /><br>
         <label class="vs-select--label w-full">Managers</label>
        <v-select  label="name"  multiple :closeOnSelect="true" v-model="dataManager"  :options="managers"   /><br>
      </div>

        <div class="flex items-center justify-between px-6">
        <h5>SCHEDULE</h5>
        <!-- <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} SCHEDULE</h4> -->
    </div>
    <vs-divider class="mb-0"></vs-divider>
     <div>
      <!-- NAME -->
      <!-- <vs-row class="pl-5 pr-10 pb-0">
     <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
           <vs-input label="Schedule Name"  v-model="currrent_schedule.name" class="mt-5 w-full" name="item-name" v-validate="'required'"/>
        <span class="text-danger text-sm" v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span>
     </vs-col>
</vs-row> -->
       <div class="slot-fields p-6 pb-0 pt-0" v-for="(date, index) in currrent_schedule.dates" :key="index">
      <br>{{index}} 
      <vs-button class="float-right" v-if="date.length==0" color="primary" size="small" @click.native="inputAdd(index)"> <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/> </vs-button>
      <div class="slot-fields" v-for="(item, dayindex) in date" :key="dayindex">
     <small style="color:red">{{getTime(index,dayindex,item.start_time,item.end_time)}}</small>
    <vs-row>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
   <flat-pickr v-model="item.start_time" :config="configdateTimePicker" class="timepicker" name="start_time" placeholder="Start time"/>
   </vs-col>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
    <flat-pickr v-model="item.end_time" :config="configdateTimePicker" class="timepicker" name="end_time" placeholder="End time"/>
    <!-- <span class="danger" @click="inputRemove(index,dayindex)" style="color:red">x</span> -->
   </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2" >
      <vs-button color="danger" size="small" @click.native="inputRemove(index,dayindex)" > <feather-icon icon="MinusIcon" svgClasses="h-4 w-4"/> </vs-button>
    </vs-col>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2" v-if="currrent_schedule.dates[index].length-1===dayindex">
      <vs-button color="primary" size="small" @click.native="inputAdd(index)"> <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/> </vs-button>
    </vs-col>

  </vs-row>
    </div>
           <vs-tooltip text="Copy to all days" position="left">
       <vs-button size="small" @click.native="copytoall()" class="p-1 mt-1" v-if="index==='Monday' && currrent_schedule.dates.Monday.length > 0 &&  currrent_schedule.dates.Monday[0].start_time.length>0 && currrent_schedule.dates.Monday[0].end_time.length>0"><feather-icon icon="ArrowDownIcon" svgClasses="w-4 h-4" /> </vs-button>    
       </vs-tooltip> 
    </div>
      </div>
    </component>
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {UPDATE_LOCATION, ALL_TIMEZONES,CREATE_NEW_LOCATION, CREATE_LOCATION, CREATE_SCHEDULE, UPDATE_SCHEDULE, ALL_MANAGERS, CHECK_LOCATION } from '@/graphql'
import Datepicker from 'vuejs-datepicker'
import vSelect from 'vue-select'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    Datepicker,
    flatPickr,
    moment
  },
  data () {
    return {
      oldSchedule:null,
      timezones : [],
      // {"label":"Eastern Standard Time (EST)","id":"EST"},
      // {"label":"Central Standard Time	(CST)","id":"CST"},
      // {"label":"Pacific Standard Time	(PST)","id":"PST"},
      // {"label":"Mountain Standard Time (MST)","id":"MST"},
      // {"label":"Alaska Standard Time (AKST)","id":"AKST"},
      // {"label":"Hawaii Standard Time	(AHST)","id":"AHST"},

      managers:[],
      dataManager:'',
      dataTimezone:'',
      dataAddress:'',
      dataPhone:'',
      dataEmail:'',
      dataPin:'',
      dataLatitude:'',
      dataLongitude:'',
      dataId: null,
      dataName: '',
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      currrent_schedule:
        {
          'id': '',
          'name': '',
          'dates': {
            Monday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Tuesday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Wednesday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Thursday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Friday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Saturday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Sunday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ]
          }
        },
      configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        timeFormat: 'H:i',
        time_24hr: false,
        altInput: true,
        dateFormat: 'H:i'
      },
      deletedschedules:[],
      LocationDuplicate:0,
    }

  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {id, name, timezone, schedule, managers, email, phone, longitude, latitude, pin_url, address} = JSON.parse(JSON.stringify(this.data))
        const getmanager = []
        const getmanagerids = []
        for (let j = 0; j < managers.length; j++) {

          getmanagerids.push(managers[j].id)
          const getfullname = `${managers[j].fname} ${managers[j].lname} - ${managers[j].email}`
          managers[j].name = getfullname
          getmanager.push(managers[j])
        }
        this.Mangerlist = getmanagerids
        this.dataManager = getmanager
        this.dataId = id
        this.dataName = name
        this.dataEmail = email
        this.dataPhone = phone
        this.dataLongitude = longitude
        this.dataLatitude = latitude
        this.dataPin = pin_url
        this.dataAddress = address
        this.dataTimezone = timezone
        this.current_cameras = []
        this.currrent_schedule.id = schedule.id
        this.currrent_schedule.name = schedule.name
        this.currrent_schedule.dates = {
          Monday: [],
          Tuesday: [],
          Wednesday: [],
          Thursday: [],
          Friday: [],
          Saturday: [],
          Sunday: []
        }
        const getarry = []
        for (let i = 0; i < schedule.scheduledates.length; i++) {
        //  delete scheduledates[i].id
          delete schedule.scheduledates[i].__typename
          var start_str = schedule.scheduledates[i].start_time
          start_str =  start_str.substring(0, start_str.length-3)
          schedule.scheduledates[i].start_time = start_str
           var end_str = schedule.scheduledates[i].end_time
          end_str =  end_str.substring(0, end_str.length-3)
          schedule.scheduledates[i].end_time = end_str
          getarry.push(schedule.scheduledates[i])
        }
          getarry.sort(function(a, b) { 
                return a.id - b.id  
              });
          this.oldSchedule=getarry
          this.oldSchedule = JSON.stringify(this.oldSchedule)
          // console.log(this.oldSchedule)
        
        for (let i = 0; i < getarry.length; i++) {
          const day = getarry[i].day
          if (day === 'Monday') {
            this.currrent_schedule.dates.Monday.push(getarry[i])
          }
          if (day === 'Tuesday') {
            this.currrent_schedule.dates.Tuesday.push(getarry[i])
          }
          if (day === 'Wednesday') {
            this.currrent_schedule.dates.Wednesday.push(getarry[i])
          }
          if (day === 'Thursday') {
            this.currrent_schedule.dates.Thursday.push(getarry[i])
          }
          if (day === 'Friday') {
            this.currrent_schedule.dates.Friday.push(getarry[i])
          }
          if (day === 'Saturday') {
            this.currrent_schedule.dates.Saturday.push(getarry[i])
          }
          if (day === 'Sunday') {
            this.currrent_schedule.dates.Sunday.push(getarry[i])
          }
        }

        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('close-sidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      this.currrent_schedule.name = `${'Location' + ' '}${  this.dataName  } ` + 'Schedule'
      return !this.errors.any() && this.dataName && this.dataTimezone && this.dataAddress && this.dataPhone.length === 14 && this.currrent_schedule.name && this.LocationDuplicate === 0
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    checkName () {
      if(this.dataName.length > 0){
      this.$apollo
        .mutate({
          mutation: CHECK_LOCATION,
          variables: {
            id:this.dataId,
            name: this.dataName
          }
        })
        .then(response => {
          this.LocationDuplicate = response.data.checkLocationName.counter
        })
    }

    },
    acceptNumber () {
      const x = this.dataPhone
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
      this.dataPhone = !x[2] ? x[1] : `(${  x[1]  }) ${  x[2]  }${x[3] ? `-${  x[3]}` : ''}`
    },
    copytoall () {
      
      if(this.currrent_schedule.dates.Tuesday && this.currrent_schedule.dates.Tuesday.length > 0){
         this.currrent_schedule.dates.Tuesday.forEach(time => {
            if(time.id){
              this.deletedschedules.push(time.id)
            }
      });
      }
      if(this.currrent_schedule.dates.Wednesday && this.currrent_schedule.dates.Wednesday.length > 0){
         this.currrent_schedule.dates.Wednesday.forEach(time => {
            if(time.id){
              this.deletedschedules.push(time.id)
            }
      });
      }
       if(this.currrent_schedule.dates.Thursday && this.currrent_schedule.dates.Thursday.length > 0){
         this.currrent_schedule.dates.Thursday.forEach(time => {
            if(time.id){
              this.deletedschedules.push(time.id)
            }
      });
      }
       if(this.currrent_schedule.dates.Friday && this.currrent_schedule.dates.Friday.length > 0){
         this.currrent_schedule.dates.Friday.forEach(time => {
            if(time.id){
              this.deletedschedules.push(time.id)
            }
      });
      }
       if(this.currrent_schedule.dates.Saturday && this.currrent_schedule.dates.Saturday.length > 0){
         this.currrent_schedule.dates.Saturday.forEach(time => {
            if(time.id){
              this.deletedschedules.push(time.id)
            }
      });
      }
       if(this.currrent_schedule.dates.Sunday && this.currrent_schedule.dates.Sunday.length > 0){
         this.currrent_schedule.dates.Sunday.forEach(time => {
            if(time.id){
              this.deletedschedules.push(time.id)
            }
      });
      }
      
      this.currrent_schedule.dates.Tuesday=[]
      this.currrent_schedule.dates.Wednesday=[]
      this.currrent_schedule.dates.Thursday=[]
      this.currrent_schedule.dates.Friday=[]
      this.currrent_schedule.dates.Saturday=[]
      this.currrent_schedule.dates.Sunday=[]
      
      for (let index = 0; index < this.currrent_schedule.dates.Monday.length; index++) {
        this.currrent_schedule.dates.Tuesday.push({
          'start_time': this.currrent_schedule.dates.Monday[index].start_time,
          'end_time': this.currrent_schedule.dates.Monday[index].end_time
        })
        this.currrent_schedule.dates.Wednesday.push({
          'start_time': this.currrent_schedule.dates.Monday[index].start_time,
          'end_time': this.currrent_schedule.dates.Monday[index].end_time
        })
        this.currrent_schedule.dates.Thursday.push({
          'start_time': this.currrent_schedule.dates.Monday[index].start_time,
          'end_time': this.currrent_schedule.dates.Monday[index].end_time
        })
        this.currrent_schedule.dates.Friday.push({
          'start_time': this.currrent_schedule.dates.Monday[index].start_time,
          'end_time': this.currrent_schedule.dates.Monday[index].end_time
        })
        this.currrent_schedule.dates.Saturday.push({
          'start_time': this.currrent_schedule.dates.Monday[index].start_time,
          'end_time': this.currrent_schedule.dates.Monday[index].end_time
        })
        this.currrent_schedule.dates.Sunday.push({
          'start_time': this.currrent_schedule.dates.Monday[index].start_time,
          'end_time': this.currrent_schedule.dates.Monday[index].end_time
        })   
      }
    },
    getTime (day, index, start_time, end_time) {
      const space = '  '
      if (start_time.toString() !== '' && end_time.toString() !== '') {
        if (end_time > start_time) {
          return ''
        } else {
          return `End Time is Less than Start Time at ${  day   }${space  }${index + 1}`
        }
      }
    },
    inputAdd (dayindex) {
      const index = this.currrent_schedule.dates[dayindex].length
      this.currrent_schedule.dates[dayindex].push({
        'start_time': '',
        'end_time': ''
      })
    },
    inputRemove (index, dayindex) {
      if (this.currrent_schedule.dates[index][dayindex].id) {
        this.deletedschedules.push(this.currrent_schedule.dates[index][dayindex].id)
      }
      this.currrent_schedule.dates[index].splice(dayindex, 1)
    },
    StatusSuccess (item, action) {
      this.$vs.notify({
        title: 'Location',
        text:  `${item} ${action} successfully`,
        color: 'success',
        position: 'top-right'
      })
    },
    StatusFail (item, action) {
      this.$vs.notify({
        title: 'Location',
        text:  `${item} ${action}`,
        color: 'danger',
        position: 'top-right'
      })
    },
    UpdateSuccess () {
      this.$vs.notify({
        title: 'Location',
        text: 'Location updated successfully',
        color: 'success',
        position: 'top-right'
      })
    },
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataName = ''
      this.currrent_schedule =
        {
          'id': '',
          'name': '',
          'dates': {
            Monday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Tuesday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Wednesday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Thursday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Friday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Saturday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Sunday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ]
          }
        },
      this.deletedschedules = []
      this.dataManager = []
      this.dataName=''
      this.dataEmail=''
      this.dataPhone=''
      this.dataLatitude=''
      this.dataLongitude=''
      this.dataPin=''
      this.dataAddress=''
      this.dataTimezone={}
    },
    submitData () {
      const getmanagerids = []
      for (let j = 0; j < this.dataManager.length; j++) {
        const getid = this.dataManager[j].id
        getmanagerids.push(getid)
      }
      let finalschedule = []
      for (let i = 0; i < this.currrent_schedule.dates.Monday.length; i++) {
        const element = this.currrent_schedule.dates.Monday[i]
        if (element['start_time'] !== '' && element['end_time'] !== '') {
          element['day'] = 'Monday'
          finalschedule.push(element)
        }
      }
      for (let i = 0; i < this.currrent_schedule.dates.Tuesday.length; i++) {
        const elementTu = this.currrent_schedule.dates.Tuesday[i]
        if (elementTu['start_time'] !== '' && elementTu['end_time'] !== '') {
          elementTu['day'] = 'Tuesday'
          finalschedule.push(elementTu)
        }
      }
      for (let i = 0; i < this.currrent_schedule.dates.Wednesday.length; i++) {
        const elementWd = this.currrent_schedule.dates.Wednesday[i]
        if (elementWd['start_time'] !== '' && elementWd['end_time'] !== '') {
          elementWd['day'] = 'Wednesday'
          finalschedule.push(elementWd)
        }
      }
      for (let i = 0; i < this.currrent_schedule.dates.Thursday.length; i++) {
        const elementTh = this.currrent_schedule.dates.Thursday[i]
        if (elementTh['start_time'] !== '' && elementTh['end_time'] !== '') {
          elementTh['day'] = 'Thursday'
          finalschedule.push(elementTh)
        }
      }
      for (let i = 0; i < this.currrent_schedule.dates.Friday.length; i++) {
        const elementFr = this.currrent_schedule.dates.Friday[i]
        if (elementFr['start_time'] !== '' && elementFr['end_time'] !== '') {
          elementFr['day'] = 'Friday'
          finalschedule.push(elementFr)
        }
      }
      for (let i = 0; i < this.currrent_schedule.dates.Saturday.length; i++) {
        const elementSa = this.currrent_schedule.dates.Saturday[i]
        if (elementSa['start_time'] !== '' && elementSa['end_time'] !== '') {
          elementSa['day'] = 'Saturday'
          finalschedule.push(elementSa)
        }
      }
      for (let i = 0; i < this.currrent_schedule.dates.Sunday.length; i++) {
        const elementSu = this.currrent_schedule.dates.Sunday[i]
        if (elementSu['start_time'] !== '' && elementSu['end_time'] !== '') {
          elementSu['day'] = 'Sunday'
          finalschedule.push(elementSu)
        }
      }
      let error = 0

      function checkSchedule (finalschedule) {
        if (finalschedule.length > 0) {
          for (let i = 0; i < finalschedule.length; i++) {
            if (finalschedule[i].end_time <= finalschedule[i].start_time) {
              error++
            }
          }
        } else {
          error++
        }
      }
      checkSchedule(finalschedule)
      this.$validator.validateAll().then(result => {
        if (result && error === 0) {
          if (this.dataId !== null && this.dataId >= 0) {
            if (this.dataLatitude && this.dataLongitude) {
              this.dataPin = `https://maps.google.com?q=${this.dataLongitude},${this.dataLatitude}`
            } else {
              this.dataPin = ''
            }
            this.$apollo
              .mutate({
                mutation: UPDATE_LOCATION,
                variables: {
                  id :this.dataId,
                  name: this.dataName,
                  email:this.dataEmail,
                  phone:this.dataPhone,
                  latitude:this.dataLatitude,
                  longitude:this.dataLongitude,
                  pin_url:this.dataPin,
                  address:this.dataAddress,
                  timezone:this.dataTimezone.id,
                  managers: getmanagerids
                }
              })
              .then(response => {
                if (response) {
                  this.StatusSuccess('Location', 'Updated')
                  this.$emit('close-sidebar')
                  this.initValues()
                }
              }).catch(error => {
                this.StatusFail('Location', 'Update Fail')
                console.log(error)
              })
            if (result && error === 0) {
              if (this.currrent_schedule.id !== '' && this.currrent_schedule.id >= 0) {
                const newschedule = []
                for (let i = 0; i < finalschedule.length; i++) {
                  if (!finalschedule[i].id) {
                    newschedule.push(finalschedule[i])
                  }
                }
                finalschedule = finalschedule.filter(function (item) {
                  if (item.id) {
                    return true
                  } else {
                    return false
                  }
                })

                //  console.log(newschedule.length,"newschedule")
                //  console.log(this.deletedschedules.length,"deletedschedules")
                 finalschedule.sort(function(a, b) { 
                  return a.id - b.id  
                });
                // var old = 
                // console.log()
                // console.log(JSON.stringify(finalschedule).length)
                // console.log(this.oldSchedule.length)
                // console.log(finalschedule.localeCompare(this.oldSchedule))
                var schedule_match = (JSON.stringify(finalschedule) == this.oldSchedule)
                // console.log(JSON.stringify(finalschedule),"new")
                // console.log(JSON.stringify(this.oldSchedule),"old")
                // console.log(schedule_match,"schedule_match")
                if(newschedule.length > 0 || this.deletedschedules.length > 0 || !schedule_match){
                this.$apollo
                  .mutate({
                    mutation: UPDATE_SCHEDULE,
                    variables: {
                      id:this.currrent_schedule.id,
                      name:this.currrent_schedule.name,
                      scheduledates: {
                        update:finalschedule,
                        create:newschedule,
                        delete:this.deletedschedules
                      }
                    }
                  })
                  .then(response => {
                    if (response) {
                      // this.StatusSuccess("Schedule","Updated")
                      this.$emit('close-sidebar')
                      this.$emit('show_schedule_alert')
                      this.initValues()
                      this.deletedschedules = []
                    }
                  }).catch(error => {
                    this.StatusSuccess('Schedule', 'Fail')
                    console.log(error)
                  })
                  }
              }
            }
          } else {
            if (this.dataLatitude && this.dataLongitude) {
              this.dataPin = `https://maps.google.com?q=${this.dataLongitude},${this.dataLatitude}`
            }
            const is_signup = true
            const signup_code = "L"+Math.random().toString().slice(2, 10)
              this.$apollo
              .mutate({
                mutation: CREATE_NEW_LOCATION,
                variables: {
                  name:this.dataName,
                  email:this.dataEmail,
                  phone:this.dataPhone,
                  latitude:this.dataLatitude,
                  longitude:this.dataLongitude,
                  pin_url:this.dataPin,
                  address:this.dataAddress,
                  timezone:this.dataTimezone.id,
                  is_signup,
                  signup_code,
                  managers: getmanagerids,
                  scheduledates:finalschedule,
                  schedule_name:this.currrent_schedule.name
                }
              })
              .then(response => {
                  if (response) {
                      const location_id = response.data.createNewLocation.location
                      this.StatusSuccess('Location', 'Created')
                      this.$emit('close-sidebar')
                      this.initValues()
                      setInterval(() => this.$emit('gotoprofile', location_id), 1000)
                      this.$emit('getdata',true)
                  }
                })
            // this.$apollo
            //   .mutate({
            //     mutation: CREATE_LOCATION,
            //     variables: {
            //       name:this.dataName,
            //       email:this.dataEmail,
            //       phone:this.dataPhone,
            //       latitude:this.dataLatitude,
            //       longitude:this.dataLongitude,
            //       pin_url:this.dataPin,
            //       address:this.dataAddress,
            //       timezone:this.dataTimezone.id,
            //       is_signup,
            //       signup_code,
            //       managers: getmanageridsz
            //     }
            //   })
            //   .then(response => {
            //     if (response) {
            //       const location_id = response.data.createLocation.id
            //       const location_name = response.data.createLocation.name
            //       this.StatusSuccess('Loaction', 'Created')
            //       this.$apollo
            //         .mutate({
            //           mutation: CREATE_SCHEDULE,
            //           variables: {
            //             name:this.currrent_schedule.name,
            //             scheduledates: {
            //               create:finalschedule
            //             }
            //           }
            //         })
            //         .then(response => {
            //           if (response) {
            //             this.$apollo
            //               .mutate({
            //                 mutation: UPDATE_LOCATION,
            //                 variables: {
            //                   id :location_id,
            //                   name:location_name,
            //                   schedule_id:response.data.createSchedule.id
            //                 }
            //               })
            //               .then(response => {
            //                 if (response) {
            //                   this.$emit('close-sidebar')
            //                   this.initValues()
            //                   setInterval(() => this.$emit('gotoprofile', location_id), 1000)
            //                   // this.$emit('getdata',true)
            //                 }
            //               })
            //           }
            //         }).catch(error => {
            //           this.StatusFail('Location', 'Update Fail')
            //           console.log(error)
            //         })
            //     }
            //   }).catch(error => {
            //     this.StatusFail('Schedule', 'Fail')
            //     console.log(error)
            //   })
          }
        } else {
          this.StatusFail('Schedule is Required', 'Failed')
        }
      })
    }
  },

  created () {
    const managers = []
    this.$apollo
      .mutate({
        mutation: ALL_TIMEZONES
      })
      .then(response => {
        this.timezones = response.data.allTimezone
      })
    this.$apollo
      .mutate({
        mutation: ALL_MANAGERS
      })
      .then(response => {
        for (let i = 0; i < response.data.role.users.length; i++) {
          if(response.data.role.users[i].status){
          const fullname = `${response.data.role.users[i].fname} ${response.data.role.users[i].lname} - ${response.data.role.users[i].email}`
          response.data.role.users[i].name = fullname
          managers.push(response.data.role.users[i])
          }

        }
        this.managers = managers
      })
  }
}

</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
